module.exports = __webpack_public_path__ + "static/media/LatestNews.0e11bca7.jpg";